import React, { useContext } from "react";
import PropTypes from "prop-types";
import { makeStyles, Typography, Box } from "@material-ui/core";
import { grayColor } from "assets/jss/material-dashboard-pro-react.js";
import Card from "components/Card/Card.js";
import AuthContext from "connections/auth/AuthProvider.js";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import CardCompetitionPositioning from "./CardCompetitionPositioning.js";
import CardVolumeMarketShare from "./CardVolumeMarketShare.js";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  panelCard: {
    marginBottom: theme.spacing(2),
    height: "100%",
    display: "flex",
    flexDirection: "column",
  },
  panelTitle: {
    textAlign: "center",
    padding: "8px 16px",
    fontWeight: 400,
    fontSize: "0.875rem",
    backgroundColor: "#FAFAFA",
    color: (props) => props.clientColor || "#1976d2",
    borderRadius: "5px 5px 0 0",
    border: `1px solid ${grayColor[11]}`,
    borderBottom: (props) => `1px solid ${props.clientColor || "#1976d2"}`,
    textTransform: "capitalize",
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: theme.spacing(0.5),
    flex: "0 0 auto",
  },
  panelTitleText: {
    fontWeight: 400,
    textAlign: "center",
  },
  panelIcon: {
    fontSize: "1rem",
  },
  panelBody: {
    flex: 1,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    overflow: "hidden",
  },
  cardSection: {
    height: "calc(50% - 8px)",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
    backgroundColor: "#fff",
    borderRadius: "4px",
  },
  cardTitle: {
    fontSize: "0.8125rem",
    fontWeight: 600,
    color: "#424242",
    padding: theme.spacing(1, 0),
    borderBottom: "1px solid #e0e0e0",
    flex: "0 0 auto",
  },
  cardContent: {
    flex: 1,
    overflow: "auto",
  },
}));

export default function MarketPanel({ programId, filters }) {
  const { userDetails } = useContext(AuthContext);
  const classes = useStyles({ clientColor: userDetails.implementation_color });
  const { t } = useTranslation();

  return (
    <Card className={classes.panelCard}>
      <Box className={classes.panelTitle}>
        <TrendingUpIcon className={classes.panelIcon} />
        <Typography className={classes.panelTitleText}>market</Typography>
      </Box>

      <Box className={classes.panelBody}>
        {/* Card 1: Competition Positioning */}
        <Box className={classes.cardSection}>
          <Typography className={classes.cardTitle}>
            {t("rgm.executive.market.competition_positioning.title")}
          </Typography>
          <Box className={classes.cardContent}>
            <CardCompetitionPositioning
              programId={programId}
              filters={filters}
            />
          </Box>
        </Box>

        {/* Card 2: Volume & Market Share */}
        <Box className={classes.cardSection}>
          <Typography className={classes.cardTitle}>
            {t("rgm.executive.market.volume_market_share.title")}
          </Typography>
          <Box className={classes.cardContent}>
            <CardVolumeMarketShare programId={programId} filters={filters} />
          </Box>
        </Box>
      </Box>
    </Card>
  );
}

MarketPanel.propTypes = {
  programId: PropTypes.number,
  filters: PropTypes.object,
};
